import { useEffect, useState } from 'react'

import { api, type SuiteLinksForMe } from '../lib/api'
import { Icon } from './ui'

// "FOCTTA Consent" and "FOCTTA Discovery" in the header (release 3.1, persona
// spec 7.4, work package T4).
//
// Plain links that open the other product in a new tab, and nothing more:
// no token, no code, no email and no role travels (persona spec P10). The
// other product signs the person in through its own sign-in page. Which
// personas see them and where they point are the API's answer
// (GET /v1/suite-links, configured in Settings > Suite links); a persona the
// links are not for, or a link nobody configured, is absent rather than a
// link that goes nowhere. A failed read shows nothing: a missing shortcut is
// not worth an error on every screen.

export function SuiteLinksView({ links }: { links: SuiteLinksForMe | null }) {
  if (!links || (!links.consent && !links.discovery)) return null
  return (
    <nav className="suite-links" aria-label="Other FOCTTA products">
      {links.consent && (
        <a
          className="suite-link"
          href={links.consent.url}
          target="_blank"
          rel="noopener noreferrer"
          data-nav-id="tprm.suite.consent"
          title={'Opens ' + links.consent.name + ' in a new tab. You sign in there as you normally do.'}
        >
          {links.consent.name} <Icon name="external" size={13} />
        </a>
      )}
      {links.discovery && (
        <a
          className="suite-link"
          href={links.discovery.url}
          target="_blank"
          rel="noopener noreferrer"
          data-nav-id="tprm.suite.discovery"
          title={'Opens ' + links.discovery.name + ' in a new tab. You sign in there as you normally do.'}
        >
          {links.discovery.name} <Icon name="external" size={13} />
        </a>
      )}
    </nav>
  )
}

export function SuiteLinks() {
  const [links, setLinks] = useState<SuiteLinksForMe | null>(null)
  useEffect(() => {
    let live = true
    api
      .suiteLinks()
      .then((l) => {
        if (live) setLinks(l)
      })
      .catch(() => {
        if (live) setLinks(null)
      })
    return () => {
      live = false
    }
  }, [])
  return <SuiteLinksView links={links} />
}
